export const GET_SUPPLIER_INVOICE_DATA = "GET_SUPPLIER_INVOICE_DATA";
export const SET_SUPPLIER_DATA_LOADING = "SET_SUPPLIER_DATA_LOADING";
export const GET_ALL_SUPPLIERS = "GET_ALL_SUPPLIERS";
export const GET_SEARCH_PRODUCTS = "GET_SEARCH_PRODUCTS";